import { render } from "./ReleaseNotesPopup.vue?vue&type=template&id=78571dea&scoped=true"
import script from "./ReleaseNotesPopup.vue?vue&type=script&lang=js"
export * from "./ReleaseNotesPopup.vue?vue&type=script&lang=js"

import "./ReleaseNotesPopup.vue?vue&type=style&index=0&id=78571dea&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78571dea"]])

export default __exports__